import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiCopy } from 'react-icons/fi';
import './AdminPanel.css';
import Navbar from './Navbar';

const PostbackPage = () => {
  const [copied, setCopied] = useState(false);
  const hostName = window.location.hostname;
  const postbackUrl = `https://${hostName}/adminBT/pstbk/?tid={tid}&event={event}&vtx=VTXBNFEPK780efsOOKMEWF`;

  const handleCopy = () => {
    navigator.clipboard.writeText(postbackUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="admin-container">
      <Navbar />
      
      <header className="admin-header">
        <h1>Postback URL</h1>
      </header>

      <motion.div 
        className="postback-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="postback-description">
          <p>Use this URL to receive postback notifications from our system. The following parameters will be automatically filled:</p>
          <ul className="postback-params">
            <li><code>{'{tid}'}</code> - Transaction ID</li>
            <li><code>{'{event}'}</code> - Event type (click/conversion)</li>
            <li><code>vtx</code> - Verification token</li>
          </ul>
        </div>

        <div className="postback-input-group">
          <input
            type="text"
            value={postbackUrl}
            readOnly
            className="postback-input"
            onClick={(e) => e.target.select()}
          />
          <motion.button
            className={`copy-button ${copied ? 'copied' : ''}`}
            onClick={handleCopy}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <FiCopy className="copy-icon" />
            {copied ? 'Copied!' : 'Copy'}
          </motion.button>
        </div>

        <div className="postback-note">
          <p><strong>Note:</strong> This URL contains a unique verification token. Keep it secure and don't share it publicly.</p>
        </div>
      </motion.div>
    </div>
  );
};

export default PostbackPage;